<template>
  <div class="list-view-item" style="border: none; background: none">
    <div
      style="
              
              width: 100%;
              background-size: cover;
              margin-top: 20px;
              border-radius: 15px;
              display: flex;
              flex-direction: column
              align-items: flex-end; justify-content: center;
              position: relative;
              background-position: center
            "
    >
      <div
        class="list-view-item-inner mb-5"
        style="top: 0px; left: 0px; width: 100%; z-index: 99"
      >
        <div class="meta-left">
          <h3
            style="
              font-weight: bold;
              font-size: 23px;
              font-family: 'Poppins', sans-serif !important;
            "
          >
            {{ item.course["title_" + $i18n.locale] }}
          </h3>
        </div>
        <div
          style="
            display: flex;
            flex: 1;
            align-items: flex-end;
            justify-content: flex-end;
            flex-direction: column;
            margin-right: 20px;
          "
          class="dark-inverted"
        >
          <span style="font-weight: bold"
            >{{ $t("courses.total_day") }} {{ item.total_step }}
            {{ $t("courses.day") }}</span
          >
          <span style="font-weight: bold"
            >{{ $t("courses.finished_day", { day: item.finished_day }) }}
          </span>
        </div>
      </div>
      <div style="display: flex; width: 100%; flex-direction: row">
        <div
          v-for="i in getStart(item.finished_day, item.total_step)"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            position: relative;
            flex: 1;
            height: 160px;
          "
        >
          <div
            style="
              width: 100%;
              height: 160px;
              display: flex;
              align-items: center;
            "
          >
            <div
              style="
                background: white;
                border-radius: 20px;
                height: 140px;
                width: calc(100% - 60px);
                z-index: 2;
                position: relative;
                margin-left: 10px;
                box-shadow: rgb(0 0 0 / 7%) 1px 5px 9px;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div
                style="
                  display: flex;
                  flex: 1;
                  flex-direction: row;
                  align-items: center;
                "
              >
                <img
                  style="width: 70px; margin-left: 15px"
                  src="/static/images/checked.png"
                  v-if="i <= item.finished_day"
                />
                <img
                  style="width: 70px; margin-left: 15px"
                  src="/static/images/padlock.png"
                  v-if="i > item.finished_day + 1"
                />
                <img @click="initStart(index, item)" />
                <div v-if="i == item.finished_day + 1" class="blob blue"></div>
                <div style="font-size: 14px; padding-left: 15px">
                  {{ $t("courses.repeat_step", { step: i }) }}
                  <br />
                  {{ item.steps.filter((k) => k.step == i).length }}
                  {{ $t("coursedetail.step") }}
                  <br />
                  <div v-if="i == item.finished_day + 1">
                    <a
                      style="
                        position: absolute;
                        right: 10px;
                        bottom: 0px;
                        border-radius: 20px;
                      "
                      v-if="getStatus(index) == 'today_finished'"
                      @click="hack(item)"
                    >
                      {{
                        moment()
                          .add({ days: 1 })
                          .set({ hour: 0, minute: 0, second: 0 })
                          .fromNow()
                      }}
                    </a>
                    <a
                      style="
                        position: absolute;
                        right: 0px;
                        bottom: 0px;
                        border-radius: 20px;
                        background-color: rgb(242, 77, 93);
                        color: white;
                      "
                      @click="initStart(index, item)"
                      class="btn btn-sm"
                      v-if="
                        getStatus(index) == 'start' ||
                        getStatus(index) == 'continue' ||
                        getStatus(index) == 'new' ||
                        getStatus(index) == 'start_next'
                      "
                    >
                      {{ $t("module.continue") }}
                    </a>
                  </div>
                </div>
              </div>
              <div
                style="
                  width: 40px;
                  height: 40px;
                  border-radius: 50%;
                  position: absolute;
                  right: -20px;
                  color: white;
                  font-size: 26px;
                  text-align: center;
                "
                :style="{
                  backgroundColor:
                    i <= item.finished_day
                      ? '#153c85'
                      : i > item.finished_day + 1
                      ? '#9fb7cc'
                      : '#f24d5d',
                }"
              >
                {{ i }}
              </div>
            </div>
            <div
              :style="{
                backgroundColor:
                  i <= item.finished_day
                    ? '#153c85'
                    : i > item.finished_day + 1
                    ? '#9fb7cc'
                    : '#f24d5d',
              }"
              style="
                border-radius: 20px;
                position: absolute;
                left: 0px;
                top: 0px;
                width: 70%;
                height: 100%;
                z-index: 1;
              "
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div
      style="
        width: 100%;
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      "
    >
      <a
        class="repeat"
        href="javascript:;"
        style="text-align: center; width: 100%; display: block; color: silver"
        @click="activePane = true"
        v-if="
          item.steps.filter((k) => k.finishedAt != null).length !=
            item.steps.filter((k) => k.repeatedAt != null).length &&
          item.finished_day > 0
        "
      >
        {{ $t("courses.repeat") }} <i class="fas fa-chevron-down"></i><br />
        {{
          $t("courses.canrepeat", {
            day: lodash.unionBy(
              item.steps.filter(
                (k) => k.finishedAt != null && k.repeatedAt == null
              ),
              "step"
            ).length,
            exercise: item.steps.filter(
              (k) => k.finishedAt != null && k.repeatedAt == null
            ).length,
          })
        }}
      </a>
      <div
        v-if="activePane == true"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: row;
          flex-wrap: wrap;
          width: 100%;
        "
      >
        <div
          v-for="repeat in lodash.unionBy(
            item.steps.filter(
              (k) => k.finishedAt != null && k.repeatedAt == null
            ),
            'step'
          )"
          style="
            width: 33%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: whitesmoke;
            padding: 5px 10px;
            border-radius: 10px;
            margin: 3px;
          "
        >
          <div
            style="
              display: flex;
              align-items: flex-start;
              justify-content: flex-start;
              flex-direction: column;
            "
          >
            <span>{{ $t("courses.repeat_step", { step: repeat.step }) }}</span>
            <span
              >{{
                item.steps.filter(
                  (k) => k.finishedAt != null && k.step == parseInt(repeat.step)
                ).length
              }}/{{
                item.steps.filter(
                  (k) => k.repeatedAt != null && k.step == parseInt(repeat.step)
                ).length
              }}
            </span>
          </div>
          <el-button
            size="mini"
            type="primary"
            round
            @click="
              activePane = false;
              $router.push({
                name: 'RepeatCourse',
                params: { course_id: item.id, step: repeat.step },
              });
            "
          >
            {{
              item.steps.filter(
                (k) => k.repeatedAt != null && k.step == parseInt(repeat.step)
              ).length == 0
                ? $t("courses.start_repeat")
                : $t("courses.continue_repeat")
            }}
          </el-button>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="$store.state.test_required_popup == true">
      <div class="search-results-body">
        <!--Search Placeholder -->
        <div class="page-placeholder">
          <div class="placeholder-content" style="width: 100%">
            <img
              class="light-image"
              src="assets/img/illustrations/placeholders/search-7.svg"
              alt=""
            />
            <img
              class="dark-image"
              src="assets/img/illustrations/placeholders/search-7-dark.svg"
              alt=""
            />
            <img src="/static/img/home.svg" style="width: 800px" />

            <h3 class="mb-3">
              {{ $t("home.read.title") }}
            </h3>
            <p class="is-larger mb-3">
              {{ $t("home.read.desc") }}
            </p>
            <button
              @click="
                $router.push({
                  name:
                    $store.state.user.test_required == 1
                      ? 'SpeedTest'
                      : 'SpeedTestExam',
                })
              "
              class="button h-button is-danger is-rounded is-elevated"
            >
              <span>{{ $t("home.read.start") }}</span>
            </button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment/min/moment-with-locales";
moment.locale("tr");
import _ from "lodash";
export default {
  name: "Course",
  props: ["item", "index"],
  data() {
    return {
      moment,
      lodash: _,
      activePane: false,
    };
  },
  beforeDestroy() {
    this.activePane = false;
  },
  methods: {
    initStart(index, item) {
      if (this.getStatus(index) == "today_finished") {
        alert(
          "Bugünkü egzersizlerini tamamladın. Yarın sonraki adıma geçebilirsin."
        );
      } else {
        if (
          this.$store.state.user.test_required == 1 ||
          this.$store.state.user.test_required_exam == 1
        ) {
          //this.$store.state.test_required_popup = true;
          //return;
        }

        this.$router.push({
          name: "CourseDetail",
          params: { course_id: item.id },
        });
      }
    },
    getStart(finished_day, total_day) {
      if (finished_day == total_day) {
        return [total_day - 2, total_day - 1, finished_day];
      }
      var start = Math.max(finished_day, 1);
      return [start, start + 1, start + 2].filter((x) => x <= total_day);
    },
    getStatus(index) {
      var course = JSON.parse(JSON.stringify(this.$store.state.courses[index]));

      course.steps = _.orderBy(
        course.steps,
        ["step", "order_no"],
        ["desc", "desc"]
      );

      if (course.steps.some((k) => k.finishedAt == null) == false) {
        return "finished";
      }
      // get last finished step
      var step = course.steps.find((k) => k.finishedAt != null);
      if (step == null) {
        return "new";
      }

      var last_finished_step = step.program.step;

      // is last step finished?
      var is_last_step_finished =
        course.steps.filter(
          (k) => k.program.step == last_finished_step && k.finishedAt != null
        ).length ==
        course.steps.filter((k) => k.program.step == last_finished_step).length;

      if (is_last_step_finished) {
        // check date is today
        if (
          step.finishedAt.indexOf(moment().format("YYYY-MM-DD")) != -1 &&
          this.$store.state.user.tester == 0
        ) {
          return "today_finished";
        } else {
          return "start_next";
        }
      } else {
        return "continue";
      }
    },
  },
};
</script>

<style>
.balloon {
  animation: balloons 4s ease-in-out infinite;
  transform-origin: bottom center;
  filter: blur(0px);
  transition: 0.3s;
}

@keyframes balloons {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-25px);
  }
}

.balloon:nth-child(2) {
  animation-duration: 3.5s;
}

.balloon:nth-child(3) {
  animation-duration: 3s;
}

.balloon:nth-child(4) {
  animation-duration: 4.5s;
}

.balloon:nth-child(5) {
  animation-duration: 5s;
}

.list-view-item:hover .notcurrent {
  filter: blur(10px);
  transition: 1s;
  transform: scale(0.8) !important;
}

.list-view-item:hover .current {
  transition: 1s;
  animation: pulse infinite;
  animation-duration: 1s;
  cursor: pointer;
}

.blob {
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  height: 50px;
  width: 50px;
  transform: scale(1);
  animation: pulse-black 2s infinite;
  margin-left: 20px;
  margin-right: 10px;
}

.blob.blue {
  border: 8px solid rgb(242 77 93);
  box-shadow: 0 0 0 0 rgba(242, 77, 93, 1);
  animation: pulse-blue 2s infinite;
}

@keyframes pulse-blue {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(242, 77, 93, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(52, 172, 224, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(52, 172, 224, 0);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Course.vue